import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggingService } from '@cm/core/logging';

/**
 *
 * @deprecated Use @cm/core/logging LoggingService
 */
@Injectable({
	providedIn: 'root',
})
export class AtsLoggerService {
	constructor(private readonly logging: LoggingService) {}

	/**
	 *
	 * @deprecated Use @cm/core/logging LoggingService.logToApi
	 */
	logToApi(error: any) {
		this.logging.logToApi(error);
	}

	/**
	 *
	 * @deprecated Use @cm/core/logging LoggingService.logToApiWithHeaders
	 */
	logToApiWithHeaders(error: any, headers: HttpHeaders) {
		this.logging.logToApiWithHeaders(error, headers);
	}

	/**
	 *
	 * @deprecated Use @cm/core/logging LoggingService.trace
	 */
	trace(...args: any[]) {
		this.logging.trace(args);
	}

	/**
	 *
	 * @deprecated Use @cm/core/logging LoggingService.debug
	 */
	debug(...args: any[]) {
		this.logging.debug(args);
	}

	/**
	 *
	 * @deprecated Use @cm/core/logging LoggingService.info
	 */
	info(...args: any[]) {
		this.logging.info(args);
	}

	/**
	 *
	 * @deprecated Use @cm/core/logging LoggingService.warn
	 */
	warn(...args: any[]) {
		this.logging.warn(args);
	}

	/**
	 *
	 * @deprecated Use @cm/core/logging LoggingService.error
	 */
	error(...args: any[]) {
		this.logging.error(args);
	}

	/**
	 *
	 * @deprecated Use @cm/core/logging LoggingService.critical
	 */
	critical(...args: any[]) {
		this.logging.critical(args);
	}
}
